export default __webpack_public_path__ + "apply45f6413.png";